import { BrowserRouter, Routes, Route } from "react-router-dom"
import Form from "./containers/Form"
import FormNoOrder from "./containers/FormNoOrder"
import FormBiolevox from "./containers/FormBiovelox"
import Home from "./containers/Home"

// import SimpleForm from "./containers/SimpleForm"
import Success from "./containers/Success"
import SuccessBiovelox from "./containers/Success_Biovelox"
import { addRecordCryotherapie } from "./services/api"
import { AcceptCryotherapie } from "./components/RHFComponents/live_components"

import "./App.css"

function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/commande" element={<Form />} />
				<Route path="/urgences" element={<FormNoOrder />} />
				<Route path="/biovelox" element={<FormBiolevox />} />
				<Route
					path="/cryotherapie"
					element={
						<FormBiolevox
							acceptComponent={AcceptCryotherapie}
							cryotherapie
							successRoute="/success-cryotherapie"
							submitRecord={addRecordCryotherapie}
						/>
					}
				/>
				{/* <Route path="/pro" element={<SimpleForm />} /> */}
				<Route path="/success" element={<Success />} />
				<Route path="/success-biovelox" element={<SuccessBiovelox />} />
				<Route
					path="/success-cryotherapie"
					element={
						<SuccessBiovelox
							title="Votre demande de location a bien été prise en compte"
							message="Vous allez recevoir un mail sous 2 jours ouvrés pour les conditions générales de ventes (paiement de la facture, caution, signature des conditions générales de ventes)."
						/>
					}
				/>
			</Routes>
		</BrowserRouter>
	)
}

export default App
